import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "freqx_formTitle" }
const _hoisted_2 = { class: "freqx_formTitle" }
const _hoisted_3 = {
  style: {"width":"100%","text-align":"center"},
  class: "mt-4"
}

import { onMounted, ref } from "vue";
import { v4 as uuidv4 } from "uuid";
import request from "@/common/request";
import { getLanguage } from "@/common/translate";
import { message } from "ant-design-vue";
import { operateLogs } from "@/common/logs";


export default /*@__PURE__*/_defineComponent({
  __name: 'alarm-beep-config',
  props: {
    factoryId: {}
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

let language: any = ref('English')
const getLang = () => {
   language.value = 'English'
}
getLang()

const props = __props;
const emit = __emit;

let _factoryId: string | null;
onMounted(() => {
  _factoryId = props.factoryId || null;
  if (_factoryId == null) {
    _factoryId = localStorage.getItem('factory_id') || null
  }
  if (_factoryId) {
    getFactorySettings(_factoryId);
  }
});

class AlarmBeepSettings {
  level1IntervalSeconds: number = 5;
  level2IntervalSeconds: number = 5;
  level3IntervalSeconds: number = 5;

  thresholdLevel1IntervalSeconds: number = 5;
  thresholdLevel2IntervalSeconds: number = 5;
  thresholdLevel3IntervalSeconds: number = 5;
}

let form = ref<AlarmBeepSettings>(new AlarmBeepSettings());

let isIntervalSet = function (settings: AlarmBeepSettings) {
  return settings.level1IntervalSeconds
      || settings.level2IntervalSeconds
      || settings.level3IntervalSeconds
      || settings.thresholdLevel1IntervalSeconds
      || settings.thresholdLevel2IntervalSeconds
      || settings.thresholdLevel3IntervalSeconds
}
const getFactorySettings = (factoryId: string) => {
  const config = {
    params: { id: factoryId },
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/factories/setting", config).then((res: any) => {
    if (res?.data?.alarmBeepSettings) {
      form.value = res.data.alarmBeepSettings;
      if (!isIntervalSet(form.value)) {
        form.value = new AlarmBeepSettings()
      }
    } else {
      form.value = new AlarmBeepSettings();
    }
  });
};

function onSubmit() {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };
  let settings = Object.assign({}, form.value);
  let body = {
    factoryId: _factoryId,
    alarmBeepSettings: settings
  }
  request.post("/api/factories/setting", body, config).then((res: any) => {
    if (res?.status == 200) {
      operateLogs("修改基础配置");
      message.success(getLanguage('提交成功', language.value));
      emit('success')
    }
  });
}



return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    model: _unref(form),
    name: "basic",
    autocomplete: "off",
    layout: "inline",
    ref: "formStateRef",
    "label-col": { style: { width: '160px' } },
    style: {"color":"#fff"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(getLanguage)('智能诊断报警', _unref(language))), 1),
      _createVNode(_component_a_form_item, {
        label: _unref(getLanguage)('可用报警') + '(' + _unref(getLanguage)('秒') + ')' 
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input_number, {
            value: _unref(form).level1IntervalSeconds,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).level1IntervalSeconds) = $event)),
            min: "-1"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_a_form_item, {
        label: _unref(getLanguage)('警戒报警') + '(' + _unref(getLanguage)('秒') + ')' 
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input_number, {
            value: _unref(form).level2IntervalSeconds,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).level2IntervalSeconds) = $event)),
            min: "-1"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_a_form_item, {
        label: _unref(getLanguage)('故障报警') + '(' + _unref(getLanguage)('秒') + ')' 
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input_number, {
            value: _unref(form).level3IntervalSeconds,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).level3IntervalSeconds) = $event)),
            min: "-1"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(getLanguage)('门限报警', _unref(language))), 1),
      _createVNode(_component_a_form_item, {
        label: _unref(getLanguage)('可用报警') + '(' + _unref(getLanguage)('秒') + ')' 
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input_number, {
            value: _unref(form).thresholdLevel1IntervalSeconds,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).thresholdLevel1IntervalSeconds) = $event)),
            min: "-1"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_a_form_item, {
        label: _unref(getLanguage)('警戒报警') + '(' + _unref(getLanguage)('秒') + ')' 
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input_number, {
            value: _unref(form).thresholdLevel2IntervalSeconds,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).thresholdLevel2IntervalSeconds) = $event)),
            min: "-1"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_a_form_item, {
        label: _unref(getLanguage)('故障报警') + '(' + _unref(getLanguage)('秒') + ')' 
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input_number, {
            value: _unref(form).thresholdLevel3IntervalSeconds,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).thresholdLevel3IntervalSeconds) = $event)),
            min: "-1"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: onSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getLanguage)('提交')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})